var map = {
	"./2factor.png": 8458,
	"./apple-logo.svg": 89239,
	"./audio.svg": 63823,
	"./clinic.svg": 3179,
	"./close-circle.png": 812,
	"./close-circle.svg": 17594,
	"./coming-icon.svg": 33444,
	"./company-icon-01.svg": 19946,
	"./company-icon-02.svg": 11321,
	"./company-icon-03.svg": 45928,
	"./company-icon-04.svg": 18759,
	"./company-icon-05.svg": 54934,
	"./company-icon-06.svg": 43157,
	"./company-icon-07.svg": 70548,
	"./company-icon-08.svg": 3683,
	"./company-icon-09.svg": 89042,
	"./company-icon-10.svg": 33048,
	"./delete.svg": 4738,
	"./drag-drop.svg": 31641,
	"./emoj-icon-01.svg": 27148,
	"./emoj-icon-02.svg": 82495,
	"./emoj-icon-03.svg": 77742,
	"./emoj-icon-04.svg": 3089,
	"./emoj-icon-05.svg": 40288,
	"./emoji-smile.svg": 11824,
	"./facebook-logo.svg": 14981,
	"./flag-01.svg": 44623,
	"./flag-02.svg": 42300,
	"./flag-03.svg": 70845,
	"./flag-04.svg": 36914,
	"./folder-minus.svg": 36828,
	"./folder.svg": 34219,
	"./gateway-01.svg": 40449,
	"./gateway-02.svg": 58706,
	"./gateway-03.svg": 8099,
	"./google-icon.svg": 68648,
	"./google-logo.svg": 30734,
	"./half-circle.svg": 53421,
	"./heart.svg": 45685,
	"./hi.svg": 5586,
	"./image.svg": 59682,
	"./integration-01.svg": 18717,
	"./integration-02.svg": 80894,
	"./integration-03.svg": 43471,
	"./integration-04.svg": 77584,
	"./integration-05.svg": 89825,
	"./integration-06.svg": 84786,
	"./like.svg": 99358,
	"./mail-01.svg": 1350,
	"./mail-02.svg": 33125,
	"./mail-03.svg": 35876,
	"./pause.svg": 34299,
	"./pause1.svg": 43152,
	"./payment-01.svg": 11817,
	"./payment-02.svg": 96730,
	"./payment-03.svg": 15787,
	"./payment-04.svg": 53636,
	"./payment-05.svg": 8357,
	"./payment-06.svg": 9222,
	"./payment-07.svg": 96759,
	"./payment-08.svg": 21280,
	"./payment-09.svg": 84081,
	"./payment-10.svg": 41499,
	"./pdf-02.svg": 99150,
	"./pdf.svg": 17603,
	"./play-01.svg": 90747,
	"./preference-01.svg": 55860,
	"./preference-02.svg": 20423,
	"./preference-03.svg": 56598,
	"./preference-04.svg": 12985,
	"./preference-05.svg": 31240,
	"./preference-06.svg": 81979,
	"./preference-07.svg": 21610,
	"./preference-08.svg": 8285,
	"./preference-09.svg": 18812,
	"./preference-10.svg": 98906,
	"./preference-11.svg": 92779,
	"./preference-12.svg": 34712,
	"./scanner.svg": 94075,
	"./scanners.svg": 50194,
	"./smile-chat.svg": 18220,
	"./storage-icon-01.svg": 74908,
	"./storage-icon-02.svg": 53935,
	"./trash-bin.svg": 31495,
	"./video.svg": 57123,
	"./voice.svg": 15903,
	"./xls.svg": 20958,
	"./zip.svg": 52776
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59945;